import React from 'react';
import PropTypes from 'prop-types';
import moment from '@g4/moment-utc';
import Traveler from './travelersInfo/Traveler';

import { CART_TRAVELERS } from '../../../../../automationHooks.json';
import { withValue } from '@g4/automation-hooks';

const ANCILLARY_BAG_TYPES = [
  'CARRY_ON_BAG',
  'CHECK_IN_BAG',
  'CARRY_ON_BAG_AIRPORT',
  'CHECK_IN_BAG_AIRPORT',
  'CARRY_ON_BAG_PREDEPARTURE',
  'CHECK_IN_BAG_PREDEPARTURE',
];

const ANCILLARY_EXTRAS = [
  'PRIORITY_BOARDING',
  'TRIP_FLEX',
  'ONBOARD_ENTERTAINMENT',
];

const propTypes = {
  flights: PropTypes.array.isRequired,
  travelers: PropTypes.array.isRequired,
  seats: PropTypes.array,
  ancillaries: PropTypes.array,
  seatSelection: PropTypes.bool,
  isTripSummary: PropTypes.bool,
  showSeatsLink: PropTypes.bool,
  showBagsLink: PropTypes.bool,
  hasBundledSeats: PropTypes.bool,
  hasBundledBagsAndExtras: PropTypes.bool,
};

const defaultProps = {
  seats: [],
  ancillaries: [],
};

const TravelersInfo = ({
  flights,
  travelers,
  seats,
  ancillaries,
  seatSelection,
  isTripSummary,
  showSeatsLink,
  showBagsLink,
  hasBundledSeats,
  hasBundledBagsAndExtras,
}) => {
  const sortedFlights = [...flights].sort((a, b) => {
    const timeA = moment(a.flight.departingTime);
    const timeB = moment(b.flight.departingTime);
    return timeA.isValid() && timeB.isValid() ? timeA.diff(timeB) : 0;
  });
  
  const getSeatsForTraveler = (id) =>
    seats.filter((seat) => seat.travelerId === id);

  const getBagsForTraveler = (id) =>
    ancillaries.filter(
      (ancillary) =>
        ancillary.travelerId === id &&
        ANCILLARY_BAG_TYPES.indexOf(ancillary.ancillaryType) > -1
    );

  const getExtrasForTraveler = (travelerId) =>
    ancillaries.filter(
      ancillary =>
        (ancillary.travelerId === travelerId) &&
        ANCILLARY_EXTRAS.indexOf(ancillary.ancillaryType) > -1
    );

  const validTravelers = travelers.filter(
    (traveler) => traveler.firstName && traveler.lastName
  );

  return validTravelers.map((traveler, index) => (
    <Traveler
      automationHook={withValue(CART_TRAVELERS.hook, index)}
      key={index}
      travelerNumber={index + 1}
      lastName={traveler.lastName}
      firstName={traveler.firstName}
      middleName={traveler.middleName}
      suffix={traveler.suffix}
      seats={getSeatsForTraveler(traveler.id)}
      bags={getBagsForTraveler(traveler.id)}
      extras={getExtrasForTraveler(traveler.id)}
      flights={sortedFlights}
      withBorder={!!index < travelers.length ? true : false}
      ssrs={traveler.ssrs}
      seatSelection={seatSelection}
      isTripSummary={isTripSummary}
      showSeatsLink={showSeatsLink}
      showBagsLink={showBagsLink}
      hasBundledSeats={hasBundledSeats}
      hasBundledBagsAndExtras={hasBundledBagsAndExtras}
    />
  ));
};

TravelersInfo.propTypes = propTypes;
TravelersInfo.defaultProps = defaultProps;

export default TravelersInfo;
